const SESAMY_PASSWORD_LOGIN_SELECTION_COOKIE_NAME =
  "sesamy-password-login-selection";

export function getPasswordLoginSelectionCookieName(
  vendor?: string | string[],
) {
  if (!vendor) {
    return SESAMY_PASSWORD_LOGIN_SELECTION_COOKIE_NAME;
  }

  const flatVendor = Array.isArray(vendor) ? vendor[0] : vendor;

  return `${SESAMY_PASSWORD_LOGIN_SELECTION_COOKIE_NAME}-${flatVendor}`;
}

export enum SesamyPasswordLoginSelection {
  password = "password",
  code = "code",
}
